import { requestApiUser } from "../functions";

export const VariantsProductsQueriesUser = {
    create: async (data) => {
        const res = await requestApiUser('/products/variants', 'POST', data);
        return res;
    },

    findById: async (id) => {
        const res = await requestApiUser(`/products/variants/${id}`, 'GET');
        return res;
    },

    findAllByProductId: async (productId) => {
        const res = await requestApiUser(`/products/variants/product/${productId}`, 'GET');
        return res;
    },
    
    update: async (id, data) => {
        const res = await requestApiUser(`/products/variants/${id}`, 'PUT', data);
        return res;
    },

    delete: async (id) => {
        const res = await requestApiUser(`/products/variants/${id}`, 'DELETE');
        return res;
    },
}